// extracted by mini-css-extract-plugin
module.exports = {"clientReferralWrapper":"ClientReferral_clientReferralWrapper__1iD6X","title":"ClientReferral_title__1RE5M","itemText":"ClientReferral_itemText__kck4P"};